<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model.trim="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzyModelSearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="1013010"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        config-module="1013010"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item ref="serialNumber" :valid="$t('FileHistory.PlsInput')" :label="$t('baseInfo.basicData.currency.serialNumber')">
            <el-input-number
              v-model="editDialog.form.serialNumber"
              no="serialNumber"
              disabled
              :min="0"
              :controls="false"
              size="mini"
              @blur="serialNumberBlur"
            />
          </el-form-item>
          <el-form-item ref="model" :valid="$t('FileHistory.PlsInput')" :label="$t('Pricing.Aircraft')">
            <el-input v-model="editDialog.form.model" no="model" :disabled="isTenant" />
          </el-form-item>
          <el-form-item ref="fullName" :valid="$t('FileHistory.PlsInput')" :label="$t('Pricing.AircraftFullName')">
            <el-input v-model="editDialog.form.fullName" no="fullName" :disabled="isTenant" />
          </el-form-item>
          <el-form-item ref="type" :valid="$t('CargoMsg.Cargo_PleaseSelect')" :label="$t('CargoMsg.Cargo_Type')">
            <el-select v-model="editDialog.form.type" no="type" :disabled="isTenant">
              <el-option
                v-for="item in airplaneModelTypes"
                :key="item.code"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            ref="totalVolume"
            :valid="$t('FileHistory.PlsInput')"
            :label="$t('SeaExport.TotalCubage')"
          >
            <el-input-number v-model="editDialog.form.totalVolume" no="totalVolume" :disabled="isTenant" :controls="false" />
          </el-form-item>
          <el-form-item
            :label="$t('SeaExport.TotalWeight2') + '(T)'"
          >
            <el-input-number v-model="editDialog.form.totalWeight" no="totalWeight" :disabled="isTenant" :controls="false" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_MaximumTakeOffWeight') + '(T)'">
            <el-input-number v-model="editDialog.form.maxTakeoffWeight" no="maxTakeoffWeight" :disabled="isTenant" :controls="false" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NumberOfCartridges')">
            <el-input-number v-model="editDialog.form.containerCount" no="containerCount" :disabled="isTenant" :precision="0" :min="0" :controls="false" />
          </el-form-item>
          <el-form-item ref="weightLimit" :valid="$t('FileHistory.PlsInput')" :label="$t('CargoMsg.Cargo_WeightRestrictions')">
            <el-input-number v-model="editDialog.form.weightLimit" no="weightLimit" :disabled="isTenant" :controls="false" />
          </el-form-item>
          <el-form-item ref="volumeLimit" :valid="$t('FileHistory.PlsInput')" :label="$t('CargoMsg.Cargo_VolumeLimit')">
            <el-input-number v-model="editDialog.form.volumeLimit" no="volumeLimit" :disabled="isTenant" :controls="false" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.remarks')">
            <el-input v-model="editDialog.form.remark" no="remark" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('CargoMsg.Cargo_Add')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-airplane-model />
      <span slot="footer">
        <el-button no="save" type="primary" @click="addFromPlatform">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { getAirplaneModelList, getAirplaneModelsByPlatform, saveAirplaneModel, addAirplaneModelByPlatform, saveAirplaneModels, delAirplaneModel } from '@/api/basicData/airplaneModel'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DataCheckUtil } from '@/class/cargo/model/utils/DataCheckUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import BaseAirplaneModel from '@/views/cargo/v0/Information/components/basicData/baseAirplaneModel'
import { deepClone } from '@/utils'

export default {
  name: 'AirplaneModel',
  components: { BaseAirplaneModel },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.serialNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('Pricing.Aircraft'),
          field: 'model',
          width: 100
        },
        {
          headerName: this.$t('Pricing.AircraftFullName'),
          field: 'fullName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Type'),
          field: 'type',
          width: 150,
          valueFormatter: (params) => {
            return CommonState.getNameByCode(SystemConstants.AIRPLANE_MODEL_TYPES, params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TotalCubage'),
          field: 'totalVolume',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.TotalWeight2') + '(T)',
          field: 'totalWeight',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MaximumTakeOffWeight') + '(T)',
          field: 'maxTakeoffWeight',
          width: 120,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NumberOfCartridges'),
          field: 'containerCount',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WeightRestrictions'),
          field: 'weightLimit',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VolumeLimit'),
          field: 'volumeLimit',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.remarks'),
          field: 'remark',
          width: 150
        }
      ],
      rowData: null,
      tenantId: '',
      airplaneModelTypes: SystemConstants.AIRPLANE_MODEL_TYPES,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNumber: '',
          model: '',
          fullName: '',
          type: '',
          totalVolume: '',
          totalWeight: '',
          maxTakeoffWeight: '',
          containerCount: '',
          weightLimit: '',
          volumeLimit: 0,
          remark: ''
        }
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isTenant() { // 是否租户
      return this.$store.getters.tenantId > 1
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getAirplaneModelList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getAirplaneModelsByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          serialNumber: this.total + 1,
          model: '',
          fullName: '',
          type: '',
          totalVolume: '',
          totalWeight: '',
          maxTakeoffWeight: '',
          containerCount: '',
          weightLimit: '',
          volumeLimit: 0,
          remark: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_AddModel')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Please_Select_The_Model_You_Want_To_Edit'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.form.serialNumber = this.editDialog.form.serialNumber ? this.editDialog.form.serialNumber : 1
        this.editDialog.title = this.$t('CargoMsg.Cargo_AddModel')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (DataCheckUtil.checkForm(this.$refs, form, this)) {
        return
      }
      let saveFunc = saveAirplaneModel
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addAirplaneModelByPlatform
      }
      saveFunc(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_Please_Select_The_Model_To_Be_Deleted'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const keys = Array.from(rows, p => p.uuid)
        delAirplaneModel(keys).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBaseAirplaneModel) {
        document.resetBaseAirplaneModel()
      } else {
        setTimeout(() => {
          document.resetBaseAirplaneModel()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseAirplaneModelRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push(deepClone(item))
      }
      saveAirplaneModels(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-form {
    /deep/ .el-input__inner{
      width: 200px;
    }
  }
</style>
